import {useActions} from "../../../hooks/useActions";
import {useTypedSelector} from "../../../hooks/useTypedSelector";


function Box(data: any) {

    const {openBox, updateUser, setTutorial, setSystemMessage} = useActions();
    const {user, tutorial, isLoading} = useTypedSelector(state => state.auth);

    let buttonsClasses = "booster6ButtonOpen booster6ButtonOpenDefault defaultButtonAnimation";
    let additionalClasses = '';
    if(data.box.type === "Seasoned"){
        buttonsClasses = "booster6ButtonOpen booster6ButtonOpenSeasoned";
        if(tutorial.isActive){
            additionalClasses = ' map-ico-gray';
        }
    }

    return (
        <div className={"booster6pBoxContainer" + data.box.type + additionalClasses}>
            <div className={buttonsClasses} onClick={async () => {

                if (isLoading || additionalClasses !== '') {
                    return;
                }

                if (data.box.price <= user.silver) {
                    await openBox(data.box.id, updateUser);

                    // Tutorial
                    if (tutorial.isActive && tutorial.step === 'ClickShop100') {
                        tutorial.isActive = false;
                        setTutorial(tutorial);
                    }
                    // end

                } else {
                    setSystemMessage({
                        isVisible: true,
                        type: 'info',
                        text: 'Not enough gems!',
                        action: null
                    })
                }

            }}></div>
        </div>

    );
}

export default Box;
